import React, {useState} from "react";
import {useSubheader} from "../../../_metronic/layout";
import {useTranslation} from "react-i18next";
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
import * as auth from "../../modules/Auth";
import {shallowEqual, useSelector,connect} from "react-redux";

const InvoicePage = ({id='',date='',transaction = '' ,amount = 0,name= 'تست'}) => {
	const suhbeader = useSubheader();
	const {t} = useTranslation()
	suhbeader.setTitle(t('Invoice'));

	const user = useSelector((state) => state.auth.user, shallowEqual);
	return(
		<>
			{/*begin::Wrapper*/}
			<div className="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
				{/*begin::Content*/}
				<div className="content  d-flex flex-column flex-column-fluid" id="kt_content">
					{/*begin::زیر هدر*/}
					<div className="subheader py-3 py-lg-8  subheader-transparent " id="kt_subheader">
						<div className=" container  d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
							{/*begin::اطلاعات*/}
							<div className="d-flex align-items-center flex-wrap mr-1">
								{/*begin::Page Heading*/}
								<div className="d-flex align-items-baseline flex-wrap mr-5">
									{/*begin::Page Title*/}
									{/*<h2 className="subheader-title text-dark font-weight-bold my-1 mr-3">
										{t('Invoice')}
									</h2>*/}
									{/*end::Page Title*/}
								</div>
								{/*end::Page Heading*/}
							</div>
							{/*end::اطلاعات*/}
						</div>
					</div>
					{/*end::زیر هدر*/}
					{/*begin::Entry*/}
					<div className="d-flex flex-column-fluid">
						{/*begin::Container*/}
						<div className=" container ">
							{/* begin::Card*/}
							<div className="card card-custom overflow-hidden">
								<div className="card-body p-0">
									{/* begin: فاکتور*/}
									{/* begin: فاکتور header*/}
									<div className="row justify-content-center bgi-size-cover bgi-no-repeat py-8 px-8 py-md-27 px-md-0"
											 style={{
												 backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-6.jpg")})`,
											 }}
									>
										<div className="col-md-9">
											<div className="d-flex justify-content-between pb-10 pb-md-20 flex-column flex-md-row">
												<h1 className="display-4 text-white font-weight-boldest mb-10">{t('Invoice')}</h1>
												<div className="d-flex flex-column align-items-md-end px-0">
													<span className="text-white d-flex flex-column align-items-md-end opacity-70">
                            <span>Bellmeet</span>
                          </span>
												</div>
											</div>
											<div className="border-bottom w-100 opacity-20" />
											<div className="d-flex justify-content-between text-white pt-6">
												{date && (
													<div className="d-flex flex-column flex-root">
														<span className="font-weight-bolde mb-2r">تاریخ</span>
														<span className="opacity-70">{date}</span>
													</div>
												)}
												{id && (
													<div className="d-flex flex-column flex-root">
														<span className="font-weight-bolder mb-2">شماره فاکتور</span>
														<span className="opacity-70">BM {id}</span>
													</div>
												)}
												{/*<div className="d-flex flex-column flex-root">
													<span className="font-weight-bolder mb-2">آدرس خریدار</span>
													<span className="opacity-70">تهران - خیابان جمهوری <br />بازار موبایل ایران</span>
												</div>*/}
											</div>
										</div>
									</div>
									{/* end: فاکتور header*/}
									{/* begin: فاکتور body*/}
									<div className="row justify-content-center py-8 px-8 py-md-10 px-md-0">
										<div className="col-md-9">
											<div className="table-responsive">
												<table className="table">
													<thead>
													<tr>
														<th className="pl-0 font-weight-bold text-muted  text-uppercase">توضیحات</th>
														<th className="text-right font-weight-bold text-muted text-uppercase">قیمت</th>
													</tr>
													</thead>
													<tbody>
													<tr className="font-weight-boldest font-size-lg">
														<td className="pl-0 pt-7">{name}</td>
														<td className="text-danger pr-0 pt-7 text-right">{amount}</td>
													</tr>
													<tr className="font-weight-boldest font-size-lg">
														<td className="pl-0 pt-7">مالیات (9%)</td>
														<td className="text-danger pr-0 pt-7 text-right">{amount * 0.09}</td>
													</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
									{/* end: فاکتور body*/}
									{/* begin: فاکتور footer*/}
									<div className="row justify-content-center bg-gray-100 py-8 px-8 py-md-10 px-md-0">
										<div className="col-md-9">
											<div className="d-flex justify-content-between flex-column flex-md-row font-size-lg">
												<div className="d-flex flex-column mb-10 mb-md-0">
													<div className="font-weight-bolder font-size-lg mb-3">مشخصات خریدار</div>
													<div className="d-flex justify-content-between mb-3">
														<span className="mr-15 font-weight-bold">نام خریدار:</span>
														<span className="text-right">{user.name}</span>
													</div>
													<div className="d-flex justify-content-between mb-3">
														<span className="mr-15 font-weight-bold">ایمیل خریدار:</span>
														<span className="text-right">{user.email}</span>
													</div>
													{transaction && (
														<div className="d-flex justify-content-between">
															<span className="mr-15 font-weight-bold">کد:</span>
															<span className="text-right">BARC0032UK</span>
														</div>
													)}
												</div>
												<div className="d-flex flex-column text-md-right">
													<span className="font-size-lg font-weight-bolder mb-1">مبلغ قابل پرداخت</span>
													<span className="font-size-h2 font-weight-boldest text-danger mb-1">{amount + (amount * 0.09)} تومان</span>
												</div>
											</div>
										</div>
									</div>
									{/* end: فاکتور footer*/}
									{/* begin: فاکتور action*/}
									<div className="row justify-content-center py-8 px-8 py-md-10 px-md-0">
										<div className="col-md-9">
											<div className="d-flex justify-content-between">
												<button type="button" className="btn btn-light-primary font-weight-bold" onClick={()=>window.print()}>دانلود فاکتور</button>
												<button type="button" className="btn btn-primary font-weight-bold" onClick={()=>window.print()}>چاپ فاکتور</button>
											</div>
										</div>
									</div>
									{/* end: فاکتور action*/}
									{/* end: فاکتور*/}
								</div>
							</div>
							{/* end::Card*/}
						</div>
						{/*end::Container*/}
					</div>
					{/*end::Entry*/}
				</div>
				{/*end::Content*/}
			</div>
			{/*end::Wrapper*/}
		</>
	)
}
export default connect(null, auth.actions)(InvoicePage)